import { css } from 'linaria';
import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { breakpointMediumHandset } from 'common/constants';
import Link from 'next/link';
const recentSearchStyle = "r1yd3t3b";
export function RecentSearches({
  searchTerms = [],
  isFocused
}) {
  const {
    t
  } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const showModule = (isFocused || isHovered) && searchTerms.length;
  return showModule ? <div className={recentSearchStyle} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <h4 className="title">{t('search:recent-searches', 'Recent Searches')}</h4>

      {searchTerms.map(search => <div key={search}>
          <Link href={`/saves/search?query=${encodeURIComponent(search)}`}>
            <a tabIndex={0}>{search}</a>
          </Link>
        </div>)}
    </div> : null;
}

require("./recent-searches.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./recent-searches.js");